export type AppListTabId =
  | "template-new"
  | "template-daily"
  | "template-total"
  | "avatar-new"
  | "avatar-daily"
  | "avatar-simple-daily";

export type AppListResultType = "template" | "avatar";

export type AppListConfig = {
  id: AppListTabId;
  label: string;
  path: string;
  defaultQuery: Record<string, string>;
  defaultHeaders: Record<string, string>;
  resultType: AppListResultType;
};

const DEFAULT_QUERY = {
  limit: "10",
};

const DEFAULT_HEADERS = {
  client_ver: "1610",
  contentLang: "9",
  app: "ocavatar",
  OS: "android",
};

export const APP_LIST_CONFIGS: AppListConfig[] = [
  {
    id: "template-new",
    label: "模版 New",
    path: "/v1/r/t/tabs/news",
    defaultQuery: { ...DEFAULT_QUERY, type: "11" },
    defaultHeaders: { ...DEFAULT_HEADERS },
    resultType: "template",
  },
  {
    id: "template-daily",
    label: "模版日榜",
    path: "/v1/r/t/tabs/tags",
    defaultQuery: { ...DEFAULT_QUERY, tag: "dailyTop", type: "11" },
    defaultHeaders: { ...DEFAULT_HEADERS },
    resultType: "template",
  },
  {
    id: "template-total",
    label: "模版总榜",
    path: "/v1/r/t/tabs/tags",
    defaultQuery: { ...DEFAULT_QUERY, tag: "trending", type: "11" },
    defaultHeaders: { ...DEFAULT_HEADERS },
    resultType: "template",
  },
  {
    id: "avatar-new",
    label: "Avatar New",
    path: "/v1/r/a/tabs/news",
    defaultQuery: { ...DEFAULT_QUERY, type: "111" },
    defaultHeaders: { ...DEFAULT_HEADERS },
    resultType: "avatar",
  },
  {
    id: "avatar-daily",
    label: "Avatar 日榜",
    path: "/v1/r/a/tabs/trendings",
    defaultQuery: { ...DEFAULT_QUERY, type: "101" },
    defaultHeaders: { ...DEFAULT_HEADERS },
    resultType: "avatar",
  },
  {
    id: "avatar-simple-daily",
    label: "Avatar Simple 日榜",
    path: "/v1/r/a/tabs/remixes",
    defaultQuery: { ...DEFAULT_QUERY, type: "101" },
    defaultHeaders: { ...DEFAULT_HEADERS },
    resultType: "avatar",
  },
];

export type AppListSavedConfig = {
  path: string;
  query: Record<string, string>;
  headers: Record<string, string>;
  updatedAt?: number;
  updatedBy?: string;
};
